
import { supabase } from '@/lib/supabase'
import { getPlanSubscriptionId, addUserToOrganization, handleOrganizationCreationError } from './organizationUtils'

export async function createOrganizationForNewUser(userId: string, metadata: any) {
  // Check if organization name exists in metadata
  if (!metadata.organization || !userId) {
    console.log('Données manquantes pour la création d\'organisation');
    return;
  }
  
  const planName = metadata.plan || 'enterprise'; // Default to enterprise if not specified
  console.log('Création manuelle de l\'organisation:', metadata.organization, planName);
  
  try {
    // Get the subscription plan ID first
    const subscriptionPlanId = await getPlanSubscriptionId(planName);
    
    // Check if the user already has an organization
    const { data: existingOrgs, error: checkError } = await supabase
      .from('organizations')
      .select('id')
      .eq('owner_id', userId)
      .maybeSingle();
    
    if (checkError) {
      console.log('Erreur lors de la vérification des organisations existantes:', checkError);
    }
    
    // If user already has an organization, don't try to create a new one
    if (existingOrgs?.id) {
      console.log('L\'utilisateur a déjà une organisation, id:', existingOrgs.id);
      return;
    }
    
    // Try RPC method with service role client if available
    console.log('Tentative de création via RPC avec l\'ID du plan');
    const { data: orgId, error: orgError } = await supabase.rpc(
      'manually_create_organization',
      { 
        p_user_id: userId,
        org_name: metadata.organization,
        plan_name: planName
      }
    )
    
    if (orgError) {
      console.error('Erreur lors de la création manuelle de l\'organisation via RPC:', orgError);
      await handleOrganizationCreationError(userId, metadata, subscriptionPlanId);
    } else {
      console.log('Organisation créée avec succès via RPC, ID:', orgId);
      // Add user to organization via secure RPC
      await addUserToOrganization(orgId, userId, subscriptionPlanId);
    }
  } catch (rpcError) {
    console.error('Exception RPC:', rpcError);
  }
}
